var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('audio',{ref:"audioElement",attrs:{"src":_vm.urlToPlay}})
}
var staticRenderFns = []

export { render, staticRenderFns }